import "./publisherDatatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  limit,
  getCountFromServer,
  startAfter,
  orderBy,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { booksColumns } from "../../datatablesource";

const PAGE_SIZE = 5;
var lastVisible;

const PublisherDatatable = ({ publisherID }) => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [dataCache, setDataCache] = useState({});

  useEffect(async () => {
    const eLibraryRef = collection(db, "eLibrary");
    const q1 = query(eLibraryRef, where("publisherID", "==", publisherID));
    const totalDocuments = await getCountFromServer(q1);
    const totalDataCount = totalDocuments.data().count;
    setTotalPages(Math.ceil(totalDataCount / PAGE_SIZE));
    console.log(totalDataCount)
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      let newData;

      if (dataCache[page]) {
        newData = dataCache[page];
      } else {
        var userQuery;

        if (lastVisible != null) {
          userQuery = query(
            collection(db, "eLibrary"),
            where("publisherID", "==", publisherID),
            orderBy("publish_on"),
            startAfter(lastVisible),
            limit(PAGE_SIZE)
          );
        } else {
          userQuery = query(
            collection(db, "eLibrary"),
            where("publisherID", "==", publisherID),
            orderBy("publish_on"),
            limit(PAGE_SIZE)
          );
        }
       

        const querySnapshot = await getDocs(userQuery);
        lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

        newData = querySnapshot.docs.map((doc) => {
          return {
            id: doc.id,
            ...doc.data(),
          };
        });

        setDataCache((prevCache) => ({ ...prevCache, [page]: newData }));
      }

      setData(newData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 100,
      align: "right",
    headerAlign: "right",
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Button
              variant="outlined"
              href={"/library/" + params.id}
              target="_blank"
            >
              View
            </Button>
          </div>
        );
      },
      sortable: false,
    },
  ];

  return (
    <div className="publisherDatatable">
      <DataGrid
        disableColumnFilter
        disableColumnMenu
        className="datagrid"
        rows={data}
        columns={booksColumns.concat(actionColumn)}
        pagination
        pageSize={PAGE_SIZE}
        rowCount={totalPages * PAGE_SIZE}
        paginationMode="server"
        loading={loading}
        onPageChange={(newPage) => setPage(newPage)}
      />
    </div>
  );
};

export default PublisherDatatable;
